import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {CheckBoxV2Props} from './CheckBoxV2Props.interface';

export function CheckBoxV2({
  checked = false,
  disabled = false,
  onChange,
  className,
  ...props
}: CheckBoxV2Props) {
  return (
    <div
      className={twMerge(
        disabled && 'opacity-30',
        'relative flex w-fit-content min-w-fit items-center',
        className
      )}
    >
      <input
        type="checkbox"
        {...(onChange ? {checked: !!checked} : {defaultChecked: !!checked})}
        disabled={disabled}
        className="absolute h-full w-full cursor-pointer opacity-0"
        onChange={onChange}
        {...props}
      />
      <Icon
        className={!checked ? 'hidden' : undefined}
        type={IconType.CheckOn}
      />
      <Icon
        className={checked ? 'hidden' : undefined}
        type={IconType.CheckOff}
      />
    </div>
  );
}
